import { gql } from '@/utils/graphql';

import { cardCalendarFragment } from './card-calendar';
import { cardShowFragment } from './card-show';
import { imagefragment } from './image';

export const archiveFragment = gql`
	fragment archiveFragment on ArchiveFieldsType {
		filters {
			seasons(first: 999) {
				nodes {
					id: databaseId
					name
					count
					isCurrent
					isSelected
					uri
				}
			}
		}
		events {
			nodes {
				...cardShowFragment
			}
		}
		eventDates {
			...cardCalendarFragment
		}
		festivals {
			nodes {
				name
				slug
				acf: festivalCustomFields {
					festivalSection {
						title
						color
						font {
							name
							file {
								node {
									mimeType
									url: relativeUrl
								}
							}
							mobileSize
							desktopSize
						}
						logo {
							node {
								...imageFragment
							}
						}
						link {
							target
							url
						}
					}
				}
			}
		}
	}
	${cardShowFragment}
	${cardCalendarFragment}
	${imagefragment}
`;
